import React from 'react';
import { Link } from 'react-router-dom';
import { useProducts } from '../hooks/useProducts';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const GamingDesksCategory = () => {
  const { products: gamingProducts } = useProducts('gaming');
  // Get all gaming desk products
  const gamingDesks = gamingProducts.filter(p => p.category === 'Gaming Desks');

  return (
    <div className="min-h-screen bg-gray-950">
      <Header />

      {/* Hero Section */}
      <section className="relative pt-24 md:pt-32 pb-16 md:pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
              Gaming Desks
            </h1>
            <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto">
              Choose from our premium gaming desk collection featuring RGB lighting, ergonomic design, and ultimate stability
            </p>
          </div>

          {/* Gaming Desks Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {gamingDesks.map((desk) => (
              <Card key={desk.id} className="group overflow-hidden hover:shadow-xl transition-all duration-300 bg-gray-900 border-gray-800">
                <div className="relative overflow-hidden aspect-[4/3]">
                  <img
                    src={desk.images[0]}
                    alt={desk.displayName || desk.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
                <CardContent className="p-6">
                  <div className="mb-2">
                    <span className="text-xs font-medium text-purple-400 uppercase tracking-wide">
                      {desk.model}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">
                    {desk.displayName || desk.name}
                  </h3>
                  <p className="text-gray-400 text-sm mb-4 line-clamp-2">
                    {desk.shortDesc}
                  </p>
                  <Link to={`/product/${desk.id}`}>
                    <Button variant="ghost" className="group/btn p-0 h-auto hover:bg-transparent text-purple-400">
                      <span className="text-sm font-medium">View Details</span>
                      <ArrowRight className="ml-2 h-4 w-4 group-hover/btn:translate-x-1 transition-transform" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GamingDesksCategory;
